import type {Transform} from '@dnd-kit/utilities';

export function parseTransform(transform: string): Transform | null {
  if (transform.startsWith('matrix3d(')) {
    const transformArray = transform.slice(9, -1).split(/, /);

    return {
      x: +transformArray[12],
      y: +transformArray[13],
      scaleX: +transformArray[0],
      scaleY: +transformArray[5],
    };
  } else if (transform.startsWith('matrix(')) {
    const transformArray = transform.slice(7, -1).split(/, /);

    return {
      x: +transformArray[4],
      y: +transformArray[5],
      scaleX: +transformArray[0],
      scaleY: +transformArray[3],
    };
  }

  return null;
}



// WEBPACK FOOTER //
// ../src/utilities/transform/parseTransform.ts